import { DTOError } from 'src/error/errors/DTOError';

import type { OrderComment } from './types';

import { ORDER_COMMENT_CHECKBOXES } from '../constants/order';

export const commentOrDefaultDTO = (data: unknown): OrderComment => {
  if (
    !data ||
    typeof data !== 'object' ||
    !('text' in data) ||
    !('checkboxes' in data)
  ) {
    return {
      text: '',
      checkboxes: ORDER_COMMENT_CHECKBOXES,
    };
  }

  if (typeof data.text !== 'string' || !Array.isArray(data.checkboxes)) {
    throw new DTOError('commentDTO', data);
  }

  return {
    text: data.text,
    checkboxes: data.checkboxes.map((checkbox) => checkboxDTO(checkbox)),
  };
};

const checkboxDTO = (data: unknown) => {
  if (
    !data ||
    typeof data !== 'object' ||
    !('text' in data) ||
    typeof data.text !== 'string'
  ) {
    throw new DTOError('checkboxDTO', data);
  }

  return {
    text: data.text,
  };
};
